

















import {
  defineComponent, ref, inject, computed, watch, PropType
} from '@nuxtjs/composition-api';

export default defineComponent({
  components: {},
  props: {},
  setup() {
    const {
      filters, isFilterSelected, selectFilter, doApplyFilters, isFilterDisabled
    }: any = inject('UseFiltersProvider');
    const attrs = [
      {
        code: 'manufacturer',
        value: 'Canada',
      },
      {
        code: 'att_quick_ship',
        value: 'Shipswithinaweek',
      },
      {
        code: 'sale',
        value: '1',
      },
      {
        code: 'new',
        value: '1',
      },
    ];
    const toggleFilters = ref();

    const selected = computed(() => ((id: string, optVal: string) => isFilterSelected(id, optVal)));

    watch(filters, () => {
      toggleFilters.value = attrs.map(({ code, value }) => {
        const filter = filters.value.find(filter => filter.attribute_code === code);
        return filter ? { filter, value } : null;
      }).filter(item => !!item);
    }, { immediate: true });

    return {
      selectFilter,
      doApplyFilters,
      toggleFilters,
      selected,
      isFilterDisabled,
    };
  },
});
